module.exports = function(app) {
	'use strict'
	app.directive('bulkDeleteDir',bulkDeleteDir);
	bulkDeleteDir.$inject=['$rootScope','postDataService','refreshtokenService','alertService','serverError','offlineError'];
	function bulkDeleteDir($rootScope, postDataService, refreshtokenService, alertService,serverError,offlineError) {
		return {
			scope:{
				objdata:'=',
				state1:'=',
				state2:'=',
				ids:'=',
				successUpdateFunc:"="	
			},
			link: function(scope, element, attrs,ctrl) {
                scope.objdata.bulkAction = function(param) {
                    if(param == 'delete' && scope.ids.length>0 ) {
                        var postFunction = function() {
                        $rootScope.hasLoaded = true;
                        postDataService.save({ 
                            param1: scope.state1,
                            param2: (scope.state2)?scope.state2:undefined,
                            param3:'bulk',
                            param4: 'delete'
                        },{
                            'ids':scope.ids,
                        }).$promise.then(function(bulkDelete){
                            alertService('success','Success ', bulkDelete.message, 2000);
                            $rootScope.hasLoaded = true;
                            if(scope.successUpdateFunc) {
                                scope.successUpdateFunc('update')
                            }
                        }, function(error){
                            if(!window.navigator.onLine) {
                              offlineError()
                              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                              return
                            } 
                            if(error.status ==401) {
                              var promise = refreshtokenService.getAccessToken();
                              promise.then(
                                function(answer) {
                                  if(answer==200) {   
                                    postFunction();
                                  }
                                },
                                function(error) {
                                },
                                function(progress) {
                                 // report progress
                              });
                            } else if(error.status ==502) {
                              serverError()
                            }  else {
                              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
                            } 
                            $rootScope.hasLoaded = true;
                          });
                        }
                        postFunction();
                    }
                }
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/bulkDeleteDirective.js
// module id = 434
// module chunks = 0